export enum HttpErrorSkipTypeEnum {
  skipError404 = 'Skip-error-404',
  skipError403 = 'Skip-error-403',
  skipError409 = 'Skip-error-409',
  skipErrorInterceptor = 'Skip-error-interceptor',
}
